import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Profilereview from "../Pages/Profilereview/Profilereview";
import Profilereviewtab from "../Pages/Profilereview/Profilereviewtab";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Profilereviewtheme() {
  return (
    <>
      <Header />
      <Profilereview />
      <Profilereviewtab />
      <Latestupdate />
      <Footer />
    </>
  );
}
